import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { GridOptions } from "ag-grid/main";
import {
  AgGridUtility,
  CommonUtility,
  DataService,
  DateUtility,
  SINGLE_ROW_HEADER,
  ServerConstantsService,
  MIN_CHAR_SEARCH_LENGTH,
  EDIT_BTN,
  Role
} from "../shared";
import { ReferenceTableService } from "../reference-table.service";
import { NotificationsService } from "angular2-notifications";
import { BehaviorSubject } from "rxjs";
import { StaffManagementRequest } from "../shared/model/StaffManagementRequest";

@Component({
  selector: "app-staff-management-summary",
  templateUrl: "./staff-management-summary.component.html",
  styleUrls: ["./staff-management-summary.component.scss"]
})
export class StaffManagementSummaryComponent implements OnInit, AfterViewInit {
  serverConstants: any;
  sharedData: any;
  refData: any;
  referralId: string = "";
  wpPersonId: string = "";
  providerId: string = "";
  roles: any[] = [];
  index: any;

  staffManagement: StaffManagementRequest;

  currentSearch: String;
  elasticSuggestions = new BehaviorSubject<any>(null);
  suggestions: any = [];
  results: any = [];

  userRequest = {
    providerId: 0,
    query: ""
  };

  countyCds: any;
  rolesCds: any;

  countyMap: any;
  rolesMap: any;

  countyJson: any;
  rolesJson: any;
  innerNav: any;

  userActionNotificationsMap: any;

  /*Grid Table*/
  gridOptions;
  gridApi: any;
  firstTime: Boolean = true;
  columnDefs: any;
  context: any;
  tabToNextCell: any;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  @ViewChild("header") header: ElementRef;
  @ViewChild("fileInput") fileInput: ElementRef;

  // US#15_01 | Story ID -> 15_01 | System Coordinator Requirement - Staff Management Enhancements | POIGAI
  searchActiveStaff: string;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private agGridUtility: AgGridUtility,
    private serverConstantsService: ServerConstantsService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {

    this.index = JSON.parse(sessionStorage.getItem("STMGT")).innerNavPages.find(
      x => x.pageId === "STMSU"
    );
    this.innerNav = JSON.parse(sessionStorage.getItem("STMGT"));

    this.http.get<any>(this.serverConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role : ' + data.roles[0].id);
            if(data.roles[0].id === 5){
                this.router.navigate(['dashboard']);
              } 
          }
        } 
        
        this.sharedData = this.dataService.getSharedDataObject();
        this.providerId = this.sharedData.get("providerId");
        //this.rolesCds = this.sharedData.get('roles');
        this.staffManagement = new StaffManagementRequest();
        // this.staffManagement.staffInfoList = [];
        this.currentSearch = "";
        this.getRoles();

        this.getColumnDefinitions();
        // On initial page load, the 'Active' Radio button will be selected by default.
        this.searchActiveStaff = 'Active';
        this.getActiveStaffManagement(this.searchActiveStaff);

      }, response => {
        console.log('error', response);
        if(response.status === 401){
          this.router.navigate(['dashboard']);
        }
      }, () => {

      });

    
  }



  // Method to to load after the VIEW
  ngAfterViewInit() {
    this.setStaffQuickFilter(this.searchActiveStaff);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onPageSizeChanged(newPageSize) {
    const value = (<HTMLInputElement>document.getElementById('page-size')).value;
    this.gridApi.paginationSetPageSize(Number(value));
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: "Name",
        //field: 'user.firstName',
        //cellStyle: {'white-space': 'normal'},
        colId: "firstName&lastName",
        valueGetter: function getName(params) {
          return params.data.firstName + " " + params.data.lastName;
        }
      },
      {
        headerName: "Username",
        field: "username",
        cellStyle: { "white-space": "normal" }
      },
      {
        headerName: "Office",
        field: "userOffices",
        valueGetter: this.getOffices,
        cellStyle: { "white-space": "normal" }
      },
      {
        headerName: "County",
        refData: this.countyJson,
        field: "userCounties",
        valueGetter: this.getCountyCds,
        cellStyle: { "white-space": "normal" }
      },
      {
        headerName: "Role",
        field: "userRoles",
        valueGetter: this.getRolesCds,
        cellStyle: { "white-space": "normal" }
      },
      {
        headerName: "Status",
        field: "userStatus",
        valueGetter: this.getUserStatus,
        cellStyle: { "white-space": "normal" }
      },
      {
        headerName: "Action",
        field: "",
        cellRenderer: this.getEditButton,
        cellStyle: { "text-align": "center !important" },
        width: 120,
        suppressFilter: true,
        suppressSorting: true
      }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === "Action") {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this
    };
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement("a");
    const image = EDIT_BTN;
    element.innerHTML = image;
    element.addEventListener("click", () => {
      // that.dataService.addValueToSharedDataMap('userStaffMngt', params.data);
      that.dataService.addValueToSharedDataMap(
        "staffMgmtUserId",
        params.data.id
      );
      that.loadStaffManagementDetails();
    });
    element.addEventListener("keydown", event => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        // that.dataService.addValueToSharedDataMap('userStaffMngt', params.data);
        that.dataService.addValueToSharedDataMap(
          "staffMgmtUserId",
          params.data.id
        );
        that.loadStaffManagementDetails();
      }
      /* else if ((!event.shiftKey && event.keyCode == 9) && (params.rowIndex == (that.staffManagement.staffInfoList.length - 1))) {
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/
    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  getOffices(params) {
    const officesArray = params.data.userOffices;
    officesArray.sort();
    return officesArray.join(", ");
  }

  getCountyCds(params) {
    const countiesArray = params.data.userCounties;
    countiesArray.sort();
    return countiesArray.join(", ");
    /*const that = params.context.component;
    let countiesArray= [];
    let counties = "";


    //If user is Provider
    if (params.data.user != null) {
      if (params.data.user.providerId != null) {
        if (params.data.userOffice != null && params.data.userOffice.id != null && params.data.userOffice.id.office != null) {
          if (params.data.userOffice.id.office.serviceCounty === undefined) {
            countiesArray= [];
          } else {
            countiesArray.push( that.convertCode(that.countyMap, params.data.userOffice.id.office.serviceCounty + "") );

          }
        }
      }
      //If user is state worker
      else {
        if (params.data.user != null && params.data.user.userCounties != null) {
          if (params.data.user.userCounties.length > 0) {
            countiesArray= [];
            for (let county of params.data.user.userCounties) {
              countiesArray.push( that.convertCode(that.countyMap, county.id.serviceCounty + "") );

            }
          }
        }
      }
    }

    countiesArray.sort();
    return countiesArray.join(', ');*/
  }

  getRolesCds(params) {
    const rolesArray = params.data.userRoles;
    rolesArray.sort();
    return rolesArray.join(", ");
    /*const that = params.context.component;
    params.data.userRoles;
    let roles= "";
    let role;
    for( let r of params.data.userRoles ){
      roles += r.id.role.name + ",";
    }
    roles = roles.substring(0, roles.length - 1);
    return roles;*/
  }

  getUserStatus(params) {
    const userStatus = params.data.userStatus;
    return userStatus;
  }

  public onQuickFilterChanged($event) {
    this.setStaffQuickFilter($event.target.value);
  }

  public showAllStaff($event) {
    this.gridOptions.api.setFilterModel(null);
    this.gridOptions.api.onFilterChanged();
  }

  private setStaffQuickFilter(filter: any) {
    this.gridOptions.api.setQuickFilter(filter);
    if (
      this.gridOptions.api.rowModel.rootNode.childrenAfterFilter.length === 0
    ) {
      this.gridOptions.api.showNoRowsOverlay();
    } else {
      this.gridOptions.api.hideOverlay();
    }
  }

  loadStaffManagementDetails() {
    this.router.navigate(["admin/staff-management/details"]);
  }

  convertCode(myMap, code) {
    if (myMap != undefined) {
      return myMap.get(code);
    }
  }

  parseRefTableData() {
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap("USER-ACTION-NOTIFICATIONS")
    );
    this.countyCds = this.data.getValueFromSharedDataMap("COUNTIES");

    this.countyMap = this.commonUtil.createMapFromList(this.countyCds);
    this.rolesMap = this.commonUtil.createMapFromList(this.roles);

    this.countyJson = this.commonUtil.createNativeMapFromList(this.countyCds);
    this.rolesJson = this.commonUtil.createNativeMapFromList(this.roles);
  }

  getRoles() {
    this.http
      .get<Role[]>(this.serverConstants.SERVER_API_URL + "/role/load")
      .subscribe(
        data => {
          if (data.hasOwnProperty("errorCode")) {
            this.notificationService.error(
              "Roles",
              this.userActionNotificationsMap.ERROR
            );
          } else {
            let roleList = data;
            if (this.roles != null) {
              for (const r of roleList) {
                this.roles.push({ name: r.name, value: r.id + "" });
              }
            }
          }
        },
        response => {},
        () => {
          this.parseRefTableData();
        }
      );
  }

  getAllStaffManagement() {
    this.http
      .post<StaffManagementRequest>(
        this.serverConstants.SERVER_API_URL + "/admin/user-mgmt/loadAll",
        this.staffManagement
      )
      .subscribe(
        (data: StaffManagementRequest) => {
          if (data == null || data.hasOwnProperty("errorCode")) {
            this.notificationService.error(
              "Load Staff Management",
              this.userActionNotificationsMap.ERROR
            );
          } else {
            this.staffManagement = data;

            /*this.dataService.addValueToSharedDataMap('providerOfficesMngt', this.staffManagement.providerOffices );
          this.dataService.addValueToSharedDataMap('providerCountiesMngt', this.staffManagement.providerCounties );
          this.dataService.addValueToSharedDataMap('rolesStaffMngt', this.staffManagement.roles );
          this.dataService.addValueToSharedDataMap('providerStaffMngt', this.staffManagement.providers );*/
          }
        },
        response => {
          this.notificationService.error(
            "Save Staff Management",
            this.userActionNotificationsMap.ERROR
          );
        },
        () => {}
      );
  }

  getActiveStaffManagement(event) {
    this.http
      .get(
        this.serverConstants.SERVER_API_URL +
          '/admin/user-mgmt/getUserByStatus?userStatus=' +
          this.searchActiveStaff
      )
      .subscribe(
        (data: StaffManagementRequest) => {
          if (data == null || data.hasOwnProperty('errorCode')) {
            this.notificationService.error(
              'Load Staff Management',
              this.userActionNotificationsMap.ERROR
            );
          } else {
            this.staffManagement = data;
          }
        },
        response => {
          this.notificationService.error(
            'Load Staff Management',
            this.userActionNotificationsMap.ERROR
          );
        },
        () => {}
      );
  }

  focusSumary(event) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.staffManagement.userVOList.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/staff-management-summary/staff-management-summary.component.ts